import {
    cardTitle,
    whiteColor,
} from "assets/jss/material-dashboard-pro-react.js"

const colourPaletteStyle = {
    cardTitle: {
        ...cardTitle,
        color: whiteColor
    }
}

export default colourPaletteStyle
